/**
 * Contain the Style for the Navigation Component
 */

//ColorManager
import ColorManager from "./../managers/ColorManager";

export default {
    nav : {
        backgroundColor: ColorManager.primaryColor
    },

    loginButton: {
        color: ColorManager.text,
        textDecoration: "none"
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/Navigation.ts